import { Component, Input, OnInit } from '@angular/core';
import { PasarelaPagoComponent } from 'src/app/pages/vista-compra/components-compra/pasarela-pago/pasarela-pago.component';
import { BalanceService } from 'src/app/services/balance.service';
import { PendingOrdersService } from 'src/app/services/pending-orders.service';
import { UiServices } from 'src/app/services/ui-services';

@Component({
  selector: 'app-previous-order-detail',
  templateUrl: './previous-order-detail.component.html',
  styleUrls: ['./previous-order-detail.component.scss'],
})
export class PreviousOrderDetailComponent implements OnInit {
  @Input() set order(value) {
    if (value) {
      this.total = 0;
      value.products.map((item) => {
        this.total += item.sale_price;
        value.id = item.orderId;
      });
      this.orders = value;
    }
  }

  public orders: any = undefined;
  public total = 0;

  constructor(
    public balaceSv: BalanceService,
    private uiSv: UiServices,
    private pendingOrdersSv: PendingOrdersService
  ) {}

  ngOnInit() {}

  completeOrder() {
    this.uiSv.showModal(
      PasarelaPagoComponent,
      {
        goPayment: true,
        continueOrder: this.orders,
      },
      'pasarela-pago'
    );
  }

  trackByItems(index, item) {
    return item.id;
  }

  async deleteOrder() {
    const res = await this.pendingOrdersSv.deleteOrder(this.orders);
    if (res) this.orders = undefined;
  }
}
